export const financePrepaid = {
  'finance.prepaid.title': 'Prepaid purchases',
  'finance.prepaid.create': 'Create purchase',
  'finance.prepaid.service': 'Service',
  'finance.prepaid.package': 'Published package',
  'finance.prepaid.customServices': 'Individual service selection',
  'finance.prepaid.addService': 'Add service',
  'finance.prepaid.removeService': 'Remove service',
  'finance.prepaid.previewPurchase': 'Preview purchase',
  'finance.prepaid.purchaseTerms': 'Purchase terms',
  'finance.prepaid.quotedQuantity': 'Quantity: {quantity}',
  'finance.prepaid.selectionRequired': 'Choose a beneficiary, branch and services with positive quantities. The total may not exceed one million units.',
  'finance.prepaid.purchasePreviewRequired': 'Obtain a current purchase preview before confirming.',
  'finance.prepaid.description': 'Funding, service units and unused balances',
  'finance.prepaid.purchase': 'Prepaid purchase',
  'finance.prepaid.beneficiary': 'Beneficiary',
  'finance.prepaid.date': 'Purchase date',
  'finance.prepaid.state': 'State',
  'finance.prepaid.pending': 'Awaiting full payment',
  'finance.prepaid.active': 'Active',
  'finance.prepaid.canceled': 'Canceled',
  'finance.prepaid.price': 'Purchase price',
  'finance.prepaid.funded': 'Funded',
  'finance.prepaid.consumed': 'Used',
  'finance.prepaid.released': 'Released',
  'finance.prepaid.remaining': 'Held balance',
  'finance.prepaid.lines': 'Services',
  'finance.prepaid.quantities': 'Purchased: {purchased}; used: {used}; returned: {returned}; available: {available}',
  'finance.prepaid.fund': 'Add funding',
  'finance.prepaid.cancel': 'Cancel purchase',
  'finance.prepaid.return': 'Return unused units',
  'finance.prepaid.loading': 'Loading prepaid purchases',
  'finance.prepaid.empty': 'No prepaid purchases',
  'finance.prepaid.emptyDetail': 'No purchases have been recorded.',
  'finance.prepaid.noMatches': 'No matching purchases',
  'finance.prepaid.noMatchesDetail': 'No purchases match the selected state.',
  'finance.prepaid.failed': 'The prepaid purchase operation could not be completed.',
  'finance.prepaid.changed': 'The purchase or source account changed. Read the stored values again.',
  'finance.prepaid.stateChanged': 'The purchase state does not allow this operation.',
  'finance.prepaid.unitsUnavailable': 'Some selected units are no longer available.',
  'finance.prepaid.fundingExceeded': 'The amount exceeds the purchase balance still awaiting payment.',
  'finance.prepaid.unsaved': 'unsaved prepaid purchase details',
  'finance.prepaid.reasonRequired': 'Enter a reason of at least three characters.',
  'finance.prepaid.previewRequired': 'Select available units and obtain a current return calculation.',
  'finance.prepaid.confirm': 'Confirm',
  'finance.prepaid.saving': 'Recording',
  'finance.prepaid.unitRange': 'Units {first} to {last}',
  'finance.prepaid.firstUnit': 'First unit',
  'finance.prepaid.quantity': 'Quantity',
  'finance.prepaid.more': 'Load more',
  'finance.prepaid.preview': 'Calculate return',
  'finance.prepaid.releaseAmount': 'Return to original funds',
  'finance.prepaid.net': 'Net',
  'finance.prepaid.tax': 'Included tax',
  'finance.prepaid.noPayout': 'The value returns to the original source accounts. No cash payout is recorded.',
  'finance.prepaid.reason': 'Reason',
  'finance.prepaid.unfunded': 'Still to fund',
  'finance.prepaid.fundsOwner': 'Source account owner',
  'finance.prepaid.account': 'Source account',
  'finance.prepaid.noAccounts': 'This owner has no active accounts.',
  'finance.prepaid.receipt': 'Source receipt',
  'finance.prepaid.receiptOption': '{date}: available {amount}',
  'finance.prepaid.noReceipts': 'No receipts on this account.',
  'finance.prepaid.receiptRequired': 'Choose a source account and receipt.',
  'finance.prepaid.maximum': 'Available for this purchase',
  'finance.prepaid.amount': 'Funding amount',
  'finance.prepaid.amountRequired': 'Enter a positive amount within the available balance.',
  'finance.prepaid.ownerInstruction': 'The account owner authorized funding this beneficiary.',
  'finance.prepaid.instructionRequired': 'Confirm the account owner\'s instruction.',
  'finance.prepaid.reference': 'Funding instruction reference',
  'finance.prepaid.referenceRequired': 'Enter the instruction reference, at least three characters.',
} as const
